import React, { ChangeEvent, forwardRef, ForwardedRef, Ref } from "react";
import './selectGenerico.css'
import Form from 'react-bootstrap/Form';
import './selectGenerico.css'
interface Option {
  valor: string | number;
  rotulo: string;
}
interface SelectGenericoProps {
  opcoes?: Option[];
  opcao?: Option;
  opcaoPadrao?: string;
  valorSelecionado?: string | number;
  onChange?: (value: string | number) => void | undefined;
  label?: string;
  mensagemError?: string;
  classe?: string;
  classPadrao?: string;
  validacaoAtiva?: boolean;
  disabled?: boolean;
  temLabel?: boolean;
}

const SelectGenerico = forwardRef((
  {
    opcoes,
    opcao,
    opcaoPadrao,
    valorSelecionado,
    onChange,
    label,
    mensagemError,
    classe,
    classPadrao,
    validacaoAtiva,
    disabled,
    temLabel,
  }: SelectGenericoProps,
  ref: Ref<HTMLSelectElement>
) => {
  const handleSelectChange = (event: ChangeEvent<HTMLSelectElement>) => {
    if (onChange) {
      onChange(event.target.value);
    }
  };

  return (
    <div>
      <label htmlFor="select" className="form-label" style={temLabel === false ? { display: 'none' } : {}}>
        {label}
      </label>
      <select
        ref={ref}
        id="select"
        value={valorSelecionado}
        onChange={handleSelectChange}
        className={`${classe} ${disabled ? 'cursorBlock' : ''}  
          `}
        aria-label="Default select example"
        disabled={disabled}
      >
        <option className={`${classPadrao}`} value="" disabled hidden>
          {opcaoPadrao}
        </option>
        {opcoes && opcoes.length > 0 ? (
          opcoes.map((opcao: any, index) => (
            <option key={index} value={opcao.valor}>
              {opcao.rotulo}
            </option>
          ))
        ) : (
          <option disabled>{mensagemError}</option>
        )}
        {opcao &&
          <option key={opcao.valor} value={opcao.valor}>
            {opcao.rotulo}
          </option>}
      </select>
    </div>
  );
});
export default SelectGenerico;
